// src/pages/timetable/Datatable.js

import { DataGrid } from "@mui/x-data-grid";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  deleteDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { userColumns } from "./datatablesource";
import { Typography, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { secondsInDay } from "date-fns/constants";

const Datatable = () => {
  const [data, setData] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const uid = queryParams.get("uid");

  useEffect(() => {
    const fetchData = async () => {
      console.log("Fetching timetable data for uid:", uid); // Log uid for debugging
      try {
        const timetableRef = collection(db, "timetable");
        let q = query(timetableRef);
    
        // Fetch data based on the user ID if provided
        if (uid) {
          q = query(timetableRef, where("doctorId", "==", uid));
        }
    
        const unsubscribe = onSnapshot(q, (snapshot) => {
          const list = [];
          snapshot.forEach((doc) => {
            const data = doc.data();
            console.log("Fetched document data:", data); // Log each document's data
            list.push({
              id: doc.id,
              whatsapp: data.whatsapp,
              timestamp: data.timestamp,
              userImage: data.userImage || "",
              userName: data.userName || "",
              email: data.email || "",
              amount: data.amount || "",
              user_id: data.user_id || "",
              status: data.status || "",
              note: data.note || "",
              availableSlots: data.availableSlots || "",
              date: data.date || "",
              timeStart: data.timeStart || "",
               secondsslottime: data.secondHalf.timeStart && data.secondHalf.timeEnd 
              ? `${data.secondHalf.timeStart} - ${data.secondHalf.timeEnd}` 
              : "",
              firstslottime: data.firstHalf.timeStart && data.firstHalf.timeEnd 
              ? `${data.firstHalf.timeStart} - ${data.firstHalf.timeEnd}` 
              : "",
              timeEnd: data.timeEnd || "",
              clinic_id: data.clinic_id || "", // Retrieve clinic_id from document
            });
          });
    
          console.log("Fetched timetable list:", list); // Log the full list of documents fetched
          setData(list);
        });
    
        return unsubscribe; // Return the unsubscribe function
      } catch (error) {
        console.error("Error fetching timetable data:", error);
        alert("Failed to fetch timetable data."); // Show an alert on error
      }
    };
    

    fetchData();

    // Cleanup function
    return () => {}; // No cleanup needed if unsubscribe is handled in fetchData

  }, [uid]); // Dependency on uid ensures useEffect runs whenever uid changes

  const handleClickOpen = (id) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const handleClose = () => {
    setOpenDialog(false);
    setDeleteId(null);
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        await deleteDoc(doc(db, "timetable", deleteId)); // Delete the document from Firestore
        handleClose(); // Close the dialog after deletion
      } catch (error) {
        console.error("Error deleting document:", error);
      }
    }
  };

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => (
        <div className="cellAction">
       
          <Button onClick={() => handleClickOpen(params.row.id)} color="secondary">
            Delete
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="datatable">
      {uid && (
        <Typography variant="body" component="h4" gutterBottom>
          Dr Timetable || Doctor ID: {uid}
        </Typography>
      )}

      <div className="datatableTitle">
        Timetables
        <Link 
          to={`/timetable/new?doctorId=${uid}&clinic_id=${data.length > 0 ? data[0].clinic_id : ""}`} 
          className="link"
        >
          Add New
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={[...userColumns, ...actionColumn]}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
      <Dialog open={openDialog} onClose={handleClose}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this item?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDelete} color="secondary">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default Datatable;
